import React from 'react';
import Order from '../../../../enums/order.enum';
import IconTightArrow from '../../../Icons/IconTightArrow/IconTightArrow';

interface TableHeadCellProps {
  optionKey: string;
  index: number;
  totalKeys: number;
  isAvailableActions: boolean;
  alignment?: string;
  isSortable: boolean;
  sort: { field: string | null; order: Order };
  onChangeSort: (field: string | null) => void;
}

const TableHeadCell: React.FC<TableHeadCellProps> = ({
  optionKey,
  index,
  totalKeys,
  isAvailableActions,
  alignment = 'text-left',
  isSortable,
  sort,
  onChangeSort
}) => {
  const isStartRadius = index === 0 ? 'rounded-tl-lg' : '';
  const isEndRadius = (index === totalKeys - 1 && !isAvailableActions) ? 'rounded-tr-lg' : '';
  const isStartPadding = index === 0 ? 'pl-5 rounded-tl-lg' : '';
  const isRightPadding = index === totalKeys - 1 ? '' : 'pr-2';
  const isEndPadding = (index === totalKeys - 1 && !isAvailableActions) ? 'pr-5' : '';
  const rightPadding = isEndPadding || isRightPadding;

  return (
    <th className={`min-w-[120px] text-xs leading-6 ${isStartRadius} ${isEndRadius}`} key={optionKey}>
      <div onClick={() => onChangeSort(optionKey)} className="flex flex-row w-full cursor-pointer">
        <span className={`text-nowrap py-1 ${isStartPadding} ${rightPadding} ${alignment}`}>
          {optionKey}
        </span>
        <IconTightArrow
          fill="inherit"
          iconClassName={`pointer ${isSortable && sort.field === optionKey ? '' : 'invisible'} ${
            sort?.order === Order.ASC ? 'rotate-0' : 'rotate-180'
          }`}
        />
      </div>
    </th>
  );
};

export default TableHeadCell;
